<template>

    <div>
        <v-menu
            max-width="80%"
            v-model="dateMenu"
            :close-on-content-click="false"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    class="datePickerText"
                    solo
                    :value="monthDisplay"
                    flat
                    readonly
                    dense
                    :persistent-placeholder="true"
                    placeholder="Bitte Monat wählen"
                    v-bind="attrs"
                    v-on="on">
                    <template v-slot:prepend-inner>
                        <v-icon small class="mr-2">fa-calendar</v-icon>
                    </template>
                    <template v-slot:append-outer>
                        <v-icon class="mt-1" @click="dateMenu=!dateMenu">fa-caret-down</v-icon>
                    </template>
                </v-text-field>
            </template>
            <v-date-picker
                v-model="month"
                type="month"
                @change="monthChanged"
                :max="maxDate"
                :first-day-of-week="firstDayOfWeek"
            ></v-date-picker>
        </v-menu>
    </div>
</template>
<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import moment from "moment-mini";


@Component({components: {}})
export default class MonthDatePicker extends Vue {
    private month: string = '';
    private dateMenu: boolean = false;

    // private getStartEndDates(date: Date): { start: Date, end: Date } {
    //     const endDate = date.AddMonths(1).AddDays(-1);
    //     return {start: date, end: endDate};
    // }

    private get monthDisplay(): string {
        if(this.month) {
        return moment(this.month).format("MMMM YYYY");
        }
        return '';
    }
    private getFormattedDate(date: Date, separator: string = "-"): string {
        if (date) {
            const dd = String(date.getDate()).padStart(2, '0');
            const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
            const yyyy = date.getFullYear();
            return yyyy + separator + mm + separator + dd;
        } else {
            return '';
        }
    }

    private get firstDayOfWeek(): number {
        return 1;
    }

    openOnChange(date: Date | undefined) {
        // if (date) {
        //     this.month = date.getMonth().toString();
        // }
    }

    private monthChanged() {
        this.dateMenu = false;
        const date = new Date(this.month);
        //console.log(date);
        const start = date;
        const end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
        this.$emit("monthChanged", {start: start, end: end, title: this.monthDisplay});
    }

    constructor() {
        super();
    }

    mounted() {
        this.openOnChange(new Date());
    }

    //TODO: get calendar week - localisation
    private setFormattedDate(startDate: string) {

    }

    private get maxDate(): string {
        return this.getFormattedDate(new Date());
    }

    private clearDateValue() {
       // this.$emit("monthChanged", {start: this.picker, end: this.picker});
        //this.$emit("input", this.weekRange[0]);
    }
}
</script>
<style>

</style>
